import type { IAuthCheckRubikaTokenQuery, IAuthRubikaNotRegistered } from '@/Module/Auth/Model/ApiModel';
import { authCheckRubikaTokenAction, authCheckShadTokenAction } from '@/Module/Auth/Store/Action';
import { authSetIsTransitioningAction } from '@/Module/Auth/Store/Slice/AuthSlice';
import { enqueueError } from '@/Module/Core/Helper';
import { CookieService } from '@/Module/Core/Service';
import type { IDispatch } from '@/Module/Store/Model';

export const checkRubikaToken = async (dispatch: IDispatch, { token }: IAuthCheckRubikaTokenQuery) => {
  try {
    const data = await dispatch(authCheckRubikaTokenAction({ token })).unwrap();
    if (data.key === 'JWT') {
      return { type: 'JWT', value: data.value.tokenInfo };
    }
    if (data.key === 'NOT_REGISTERED') {
      const { outerUserId, name, family } = data.value as IAuthRubikaNotRegistered;
      const rubikaUser: IAuthRubikaNotRegistered = { outerUserId, name, family };
      CookieService.setRubikaUser(JSON.stringify(rubikaUser));
      return { type: 'NOT_REGISTERED', value: rubikaUser };
    }
  } catch (error: any) {
    if (error?.data?.responseDesc === 'InvalidToken') {
      enqueueError('اعتبار توکن شما به پایان رسیده است، لطفاً از برنامه خارج شده و مجدداً وارد شوید.');
      return { type: 'INVALID_TOKEN' };
    }

    enqueueError('مشکلی پیش آمده است، لطفاً از برنامه خارج شده و مجدداً وارد شوید.');
    return error;
  }
  return '';
};

export const checkShadToken = async (dispatch: IDispatch, { token }: IAuthCheckRubikaTokenQuery) => {
  try {
    dispatch(authSetIsTransitioningAction(true));
    const data = await dispatch(authCheckShadTokenAction({ token })).unwrap();
    if (data.key === 'JWT') {
      return { type: 'JWT', value: data.value.tokenInfo };
    }
  } catch (error: any) {
    if (error.message.includes('503')) {
      enqueueError('سرویس ورود به شاد موقتاً در دسترس نیست، لطفاً بعداً تلاش کنید.');
    } else {
      enqueueError('مشکلی پیش آمده است، لطفاً از برنامه خارج شده و مجدداً وارد شوید.');
    }
    return error;
  }
  return '';
};
